import { Button,CardBody, Col, Input, Label, Row ,FormGroup,Form, Card} from "reactstrap";
import { Modal ,ModalBody,ModalHeader,ModalFooter} from  'reactstrap'
import { useForm } from "react-hook-form";
import { useEffect,useState } from "react";
import ApiService from "../../../services/apiService";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import routes from "../../../routers/routes";
import CommonCardHeader from "../../../coreComponents/CommonCardHeader";
import { useNavigate } from "react-router-dom";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";
import { editUserTitle, PostalCode, usersTitle } from "../../../constants";
import { useRef } from "react";
import userimg from '../../../../public/Images/user-profile.jpg'
import { useAppDispatch } from "../../../reduxToolkit/hooks";
import { profileUpdate } from "../../../reduxToolkit/reducers/layout/UpdateProfileSlice";

const EditUserProfile = ({userId} : {userId :any}) => {
    const { register, handleSubmit,setValue } = useForm();
    const [userDetails,setUserDetails] = useState<any>(null);
    const[additionalData,setAdditionalData] = useState<any>({});
    const navigate = useNavigate();
    const [userImage, setUserImage] = useState<File | null>(null);
    const [previewUrl, setPreviewUrl] = useState(null);
    const[imageData,setImageData] = useState<any|[]>([]);
    const [isDeleteModalOpen,setIsDeleteModalOpen ] = useState(false)
    const[refresh, setRefresh] = useState(false);
    const[deleteImg, setDeleteImg] = useState(false);
    const[postImg,setPostImg] = useState(false);
     const dispatch = useAppDispatch();

    console.log(userId);

    const fileInputRef =  useRef<HTMLInputElement | null>(null);

    const handleButtonClick = () => {
      
       setIsDeleteModalOpen(false)
       setRefresh((prev) => !prev)
    };
   
    const handleImageUpdate = async (event:any) => {

       
      const file = event.target.files?.[0];
      if (!file) return;
    
      setUserImage(file);
       // For image preview
    
     
      const formData = new FormData();
      formData.append("file", file);
      formData.append("IdentityUserId", userId);
    
      try {
        const response = await ApiService.axiosApi(`/image/${imageData[0].id}`, {
          method: "PUT",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
    
        if (response.success) {
           dispatch(profileUpdate());
          toast.success("Profile photo updated successfully");
        } else {
          toast.error("Unable to update profile photo");
        }
      } catch (error: any) {
        console.error(error);
        toast.error("Error updating profile photo");
      }
    };
    

    useEffect(()=>{
         const getImage = async () =>{
           
          try{
            const response = await ApiService.axiosApi(`/image`,{
                method : 'GET',
            })
            if(response.success){
                console.log(response.data)
                const user = response.data
                const image = user.filter((x:any) => x.identityUserId == userId)
                console.log(image)
                setImageData(image)
              
            }else{
              console.log("unable to get all image")
            }
          }catch(error){
            console.log(error)
          }
         }
         getImage();
           

        
    },[postImg,deleteImg])

    useEffect(() =>{
      const getUserImage = async()=>{
           console.log(imageData)
        try{
            const response = await ApiService.axiosApi(`/image/${imageData[0].id}`,{
             method:'GET'
            })
            if(response.success){
             console.log(response.data)
               setPreviewUrl(response.data.filePath)
            }else{
              console.log("unable to get userimage")
            }

        }catch(error){
         console.log(error)
        }
     }
      getUserImage();

    },[imageData,refresh,deleteImg,])

    const handleImageChange = async (e: any) => {
      const file = e.target.files?.[0];
      if (!file) return;
    
      setUserImage(file);
       // For image preview
    
      const formData = new FormData();
      formData.append("file", file); // Assumes backend expects "file"
      formData.append("IdentityUserId", userId); // If needed by the API
    
      try {
        const response = await ApiService.axiosApi("/image", {
          method: "POST",
          data: formData,
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
    
        if (response.success) {
           dispatch(profileUpdate())
          console.log(response.message);
            setPostImg((prev) => !prev)

        } else {
          console.log(response.message || "Unable to store image");
        }
      } catch (error: any) {
        console.log(error);
      }finally {
       
        if (e.target) {
          e.target.value = null;
        }
      }
    };
   

    useEffect(() =>{
       
      const fetchUserDetail = async ( ) =>{

        try{
          const response = await ApiService.axiosApi('/userdetails',{
            method :'GET'
          })
            if(response.success){
                 console.log(response.data)
               const userDetail = response.data.find((user :any) => user.identityUserId == userId);
                console.log(userDetail)
               setAdditionalData(userDetail)
                 console.log(additionalData)

               setValue("firstName",userDetail.firstName);
               setValue("lastName",userDetail.lastName);
               setValue("address",userDetail.address);
               setValue("city",userDetail.city);
               setValue("postalCode",userDetail.postalCode)
               setValue("country",userDetail.country)
               setValue("village",userDetail.village)
              }
                else{
                  console.log("not able to get userdetail")
                } 
        }catch(error:any){
            console.log(error)
        }
      }
      fetchUserDetail()
    },[]);
  
    useEffect(() => {

           const fetchUser = async () =>{
              
              try{
                  const response = await ApiService.axiosApi(`/auth/${userId}`, {
                  method: 'GET',
                  });

                 if(response.success){
                       setUserDetails(response.data);
                
                    }else{
                           toast.error(response.message);
                        }
                }      catch (error: any){
                          toast.error(error.message || "Failed to fetchuser");
                        }
            }

          if(userId){
            fetchUser();
          }
   
           
    }, []);

    const onSubmit = async (data: any) => {
        try{
            const userData = {
                FirstName: data.firstName,
                LastName: data.lastName,
                Address: data.address,
                City: data.city,
                PostalCode: data.postalCode,
                Country: data.country,
                IdentityUserId: userDetails.id,
                Village : data.village,
            }
            const response = await ApiService.axiosApi(`/userdetails/${additionalData.id}`, {
                method: 'PUT',
                data: userData,
            });

            if(response.success){
                toast.success("User details updated successfully");
                navigate(routes.Users);
            }else{
                toast.error(response.message);
            }
        }catch(error:any){
            toast.error(error.message || "Failed to fetch user details");
        }
    }

    const deleteProfile = async() => {
        try{ 
              console.log(imageData[0].id)
           const response = await ApiService.axiosApi(`/image/${imageData[0].id}`,{

            method:'DELETE'
           })
           if(response.success){
              dispatch(profileUpdate());
              toast.success("PROFILE REMOVE SUCCESSFULLY")
             setDeleteImg((prev) => !prev)
           }else{
              console.log("unable to remove profile" )
           }
        }catch(error){
          console.log(error)
        }
    } 
  

  return (
    <>
 
    <div style={{width : '100%' ,height: '600px'}}>
    <Card className="p-5 pt-1 pb-0 my-0" style={{ height: '600px', width : "100%"}}>
    <CommonCardHeader title={ additionalData?.firstName && additionalData?.lastName 
      ? `${additionalData.firstName} ${additionalData.lastName}` 
      : "Edit User Profile"} headClass="pb-3 px-1" />
    <Form  onSubmit={handleSubmit(onSubmit)}  >
    {/* First Name and Last Name in the same row */}
  
      
       <FormGroup className="text-left d-flex ">
        <div>
            <Label htmlFor="profilePicUpload">
              <img
                src={previewUrl||'/Images/user-profile.jpg'}
                alt="Profile"
                className="profile-pic-upload"
                style={{
                  width: "120px",
                  height: "120px",
                  borderRadius: "50%",
                  objectFit: "cover",
                  cursor: "pointer",
                  border: "2px solid #ccc",
                  transition: "0.3s",
                }}
              />
            </Label>
            </div>
            <div className="d-flex mx-2">
             <div style={{marginLeft :'40px'}}>
              <Button 
             
              color="secondary"
                 size="sm"
                className="mt-2"
                onClick={()=> setIsDeleteModalOpen(true)}
              
                >Edit Profile</Button>
            </div>

            <div style={{marginLeft :'10px'}}>
               <Button 
            
              color="secondary"
                 size="sm"
                className="mt-2"
                onClick={deleteProfile}
              
                >delete</Button>
                  </div>
                </div>
            <input
              type="file"
              accept="image/*"
              id="profilePicUpload"
              style={{ display: "none" }}
              onChange={handleImageChange}
            />
           
          </FormGroup>
            <p className="mt-2 text-muted" style={{ fontSize: "0.85rem" }}>
              Click the picture to upload
            </p>

    <Row >
      <Col md={6}>
        <FormGroup>
         <Label className="col-form-label">FirstName</Label>
          < input
                className="form-control"
                type="text"
                placeholder="Enter First Name"
                {...register("firstName", {
                  required: "FirstName is required"
                })}
              />
        </FormGroup>
      </Col>
      <Col md={6}>
        <FormGroup>
          <Label className="col-form-label">Last Name</Label>
          <input 
          type="text"
          className="form-control"
            {...register("lastName", {
                  required: "lastName is required"
                })}
           placeholder="Enter Last Name" />
        </FormGroup>
      </Col>
    </Row>

    {/* Address in a separate row */}
    <Row>
      <Col md={6}>
        <FormGroup>
         <Label className="col-form-label">Address</Label>
          <input 
          className="form-control"
          type="text"
            {...register("address", {
                  required: "address is required"
                })}
           placeholder="Enter address" />
        </FormGroup>
      </Col>

      <Col md={6}>
        <FormGroup>
         <Label className="col-form-label">Village</Label>
          <input 
          className="form-control"
          type="text"
            {...register("village", {
                  required: "village is required"
                })}
           placeholder="Enter village" />
        </FormGroup>
      </Col>
    </Row>

    {/* City, Postal Code, and Country in the same row */}
    <Row>
      <Col md={4}>
        <FormGroup>
          <Label className="col-form-label">City</Label>
          <input 
          className="form-control"
          type="text"
            {...register("city", {
                  required: "city is required"
                })}
           placeholder="Enter city" />
        </FormGroup>
      </Col>
      <Col md={4}>
        <FormGroup>
             <Label className="col-form-label">Postal Code</Label>
          <input 
          className="form-control"
          type="text"
            {...register("postalCode", {
                  required: "PostalCode is required"
                })}
           placeholder="Enter postalCode" />
        </FormGroup>
      </Col>
      <Col md={4}>
        <FormGroup>
           <Label className="col-form-label">Country</Label>
          <input 
          className="form-control"
              type="text"
            {...register("country", {
                  required: "country is required"
                })}
           placeholder="Enter Country" />
        </FormGroup>
      </Col>
    </Row>

    {/* Submit Button */}
    <Row>
      <Col md={12}>
        <Button color="primary">Submit</Button>
      </Col>
    </Row>

  </Form>
   </Card>

   <Modal isOpen={isDeleteModalOpen} toggle={() => setIsDeleteModalOpen(!isDeleteModalOpen)}>

<ModalHeader>Update profile</ModalHeader>
<ModalBody>
   <Row>
   <input
              type="file"
              accept="image/*"
              id="profilePicUpload"
              ref={fileInputRef}
              onChange={handleImageUpdate}
            />
   </Row>
  
</ModalBody>
<ModalFooter>
    <Button color="danger" onClick={()=>handleButtonClick()}>Update</Button>
    <Button color="secondary" onClick={() => setIsDeleteModalOpen(false)}>Cancel</Button>
</ModalFooter>

</Modal>
  </div>
  </>
  )
};

export default EditUserProfile;

